import { api } from '../../services/api';

const PLANOGRAMS_URL = '/planograms/';

export const getData = (filters) =>
  api.get(`${PLANOGRAMS_URL}?${filters}`);
